import React from 'react';
import styled from 'styled-components';
import { Card, Icon, IconButton, Tooltip, Typography } from '@material-ui/core';
import { CardContent, ConfigFieldControl } from '@sierralabs/core-ui';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useSiteContext } from '../../SiteContext';
import { SiteComponent } from '../SiteComponentPlugin';
import { SiteComponentStackConfigurator } from './SiteComponentStackPlugin';
const StyledCard = styled(Card) `
  position: relative;
  .title {
    margin-top: 0;
    font-weight: 500;
  }
  .audit-log {
    position: absolute;
    top: 12px;
    right: 12px;
  }
`;
export const SiteEntityStatusCard = props => {
    const component = useSubscribeComponentChanges(SiteEntityStatusCardPlugin, props);
    const { icon, title = 'Untitled' } = component.props || {};
    const { isHover, hoverProps } = useSiteContext();
    const classes = ['site-card'];
    if (isHover(component)) {
        classes.push('component-hover');
    }
    const status = 'Draft';
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteEntityStatusCardPlugin }, props),
        React.createElement(StyledCard, Object.assign({ className: classes.join(' ') }, hoverProps(component)),
            React.createElement(CardContent, { background: 'primary' },
                React.createElement(Typography, { variant: 'overline', style: { margin: 0, paddingTop: '20px' } }, "Status"),
                React.createElement(Typography, { variant: 'h4', className: 'title' }, status),
                React.createElement(Tooltip, { title: 'Audit Log', placement: 'left', arrow: true },
                    React.createElement(IconButton, { className: 'audit-log', size: 'small', color: 'secondary' },
                        React.createElement(Icon, null, "history")))))));
};
export const SiteEntityStatusCardConfigurator = props => {
    const { component, update } = useConfigComponent(props.component);
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigFieldControl, null),
        React.createElement(SiteComponentStackConfigurator, { component: props.component })));
};
export const SiteEntityStatusCardPlugin = {
    name: 'Entity Status Card',
    type: 'entity-status-card',
    component: SiteEntityStatusCard,
    configurator: SiteEntityStatusCardConfigurator
};
//# sourceMappingURL=SiteEntityStatusCardPlugin.js.map